import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    MyTimesheetEntryGroupId,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';
import { makeSelectMyTimesheetEntryGroupId } from 'services/myTimesheetEntries/selectors';
import GroupName from 'components/GroupName';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    groupId?: MyTimesheetEntryGroupId;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryGroupComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { groupId } = this.props;

        return <GroupName groupId={groupId} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    groupId: makeSelectMyTimesheetEntryGroupId()
});

export default connect(mapStateToProps)(MyTimesheetEntryGroupComponent);
